import projectData from 'ProjectData/project'
import libraryData from 'RootData/library'
import templateData from 'ProjectData/template'
import axios from 'axios'

const state = {
  materials: [],
  basematerials: [],
  template: []
}

const getters = {
  getState (state) {
    return state
  },
  getMaterialByProperty: (state) => (property, value) => {
    return state.materials.find(item => item[property] === value)
  }
}

const actions = {
  async fetchData ({ commit }, {scene}) {
    let response = await axios
      .get(templateData)
    commit('setTemplate', response.data)

    response = await axios
      .get(libraryData)
    commit('setBaseMaterials', response.data)

    response = await axios
      .get(projectData)
    const currentScene = response.data.scenes.find(sc => sc.sceneuid === scene.sceneuid)
    commit('setMaterials', currentScene)
  }
}

const mutations = {
  updateTitle (state, payload) {
    let idx = state.materials.findIndex(item => item.name === payload.groupname)
    if (idx > -1) {
      state.materials[idx].currentTitle = state.materials[idx].title + ': ' + payload.pickedOption
      state.materials[idx].swatch = payload.swatch
      state.materials[idx].icon = payload.icon
    }
  },
  updateVisible (state, payload) {
    let idx = state.materials.findIndex(item => item.name === payload.groupname)
    if (idx > -1) {
      state.materials[idx].visible = payload.pickedOption
    }
  },
  setTemplate (state, data) {
    state.template = data.template.materials
  },
  setMaterials (state, data) {
    if (data.materials !== undefined) {
      for (let mtl of data.materials) {
        if (mtl.template !== undefined) {
          const template = state.template.find(tmpl => tmpl.name === mtl.template)
          if (template !== undefined) {
            Object.assign(mtl, template)
          }
        }

        if (mtl.options.length > 0) {
          mtl.currentTitle = mtl.title + ': ' + mtl.options[0].title
          mtl.swatch = mtl.options[0].swatch
          mtl.icon = mtl.options[0].icon
        } else {
          mtl.currentTitle = mtl.title
        }
      }
    }
    state.materials = data.materials
  },
  setBaseMaterials (state, data) {
    state.basematerials = data.library.materials
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
